import * as React from 'react';
import { useState } from 'react';
import { PaginatedContext, ContextValue } from '../components/management/pagination/paginated-context';
import { ClientSortingOptions } from '../models/enums/adminSortingOptions';
import BaseClient from '../models/base-client';

const defaultState: PaginatedContext<BaseClient> = {
  loading: false,
  results: [],
  currentPage: 1,
  totalResults: 0,
  pageSize: 60,
  orderColumn: ClientSortingOptions.Name,
  orderDirection: 'asc',
  searchTerm: null
};

const PaginatedClientContext = React.createContext<ContextValue<BaseClient>>(null);

const PaginatedClientConsumer = PaginatedClientContext.Consumer;

const PagedClientProvider = props => {
  const [state, setState] = useState<PaginatedContext<BaseClient>>(defaultState);

  const dispatch = (newValue: any) => {
    setState(prevState => {
      return { ...prevState, ...newValue };
    });
  };

  return (
    <PaginatedClientContext.Provider value={{ ...state, dispatch }}>{props.children}</PaginatedClientContext.Provider>
  );
};

export { PaginatedClientContext, PagedClientProvider, PaginatedClientConsumer };
